import Handler from "../Handler";

class DisconnectionTimeHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message)
    this.service.processPlayerDisconnectionTime(receivedData);
  }
}

export default DisconnectionTimeHandler;